export default "__VITE_ASSET__DimGqfyJ__"